import { FC, useContext, createContext } from "react"
import { MutateEncryptionMappingsContextProps } from "./mutateEncryptionMappingsController"


const MutateEncryptionMappingsContext = createContext<MutateEncryptionMappingsContextProps>({
  currTable: undefined,
  setCurrTable: () => {},
  mappingAmend: {
    mapped: 0,
    skip: 0,
    'pending-review': 0,
  },
  setMappingAmend: () => {},
  fieldListCtrl: {} as any,
  updateEditsCount: () => {},
  setFormikCtrl: () => {},
  classifications: [] as any,
})

export const MutateEncryptionMappingsContextProvider: FC<{ value: MutateEncryptionMappingsContextProps }> = ({ children, value }) => {
  return (
    <MutateEncryptionMappingsContext.Provider value={value}>
      {children}
    </MutateEncryptionMappingsContext.Provider>
  )
}

export const useMutateEncryptionMappingsContext = () => useContext(MutateEncryptionMappingsContext);


